$('.customer__item').slick({
  centerMode: false,
  centerPadding: '60px',
  slidesToShow: 1,
  autoplay: false,
  arrows: false,
  asNavFor: '.customer__item2, .customer__item3',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesPerRow: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 320,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
  ],
});
$('.customer__item2').slick({
  centerMode: false,
  centerPadding: '60px',
  slidesToShow: 1,
  arrows: false,
  autoplay: false,
  asNavFor: '.customer__item, .customer__item3',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesPerRow: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 320,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
  ],
});
$('.customer__item3').slick({
  centerMode: false,
  centerPadding: '60px',
  slidesToShow: 1,
  dots: true,
  arrows: false,
  appendDots: '.slick-dotees',
  autoplay: false,
  asNavFor: '.customer__item2, .customer__item',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesPerRow: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 320,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
  ],
});

$('.ingridient__slider1').slick({
  centerMode: false,
  centerPadding: '60px',
  slidesToShow: 1,
  dots: true,
  arrows: false,
  appendDots: '.dots1',
  autoplay: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesPerRow: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 320,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
  ],
});

$('.ingridient__slider2').slick({
  centerMode: false,
  centerPadding: '60px',
  slidesToShow: 1,
  dots: true,
  arrow: false,
  appendDots: '.dots2',
  autoplay: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesPerRow: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 320,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
  ],
});
$('.ingridient__slider3').slick({
  centerMode: false,
  centerPadding: '60px',
  slidesToShow: 1,
  dots: true,
  arrow: false,
  appendDots: '.dots3',
  autoplay: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesPerRow: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 320,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
  ],
});
